import { render } from "./VerifyPage.vue?vue&type=template&id=95619a92&scoped=true"
import script from "./VerifyPage.vue?vue&type=script&lang=js"
export * from "./VerifyPage.vue?vue&type=script&lang=js"

import "./VerifyPage.vue?vue&type=style&index=0&id=95619a92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95619a92"]])

export default __exports__